<template>
  <div class="d-flex flex-wrap">
    <v-card
      width="200px"
      class="mr-5 mb-5"
      v-for="(item, i) in items"
      :key="i"
      outlined
    >
      <v-card-text>
        <image-view
          width="100%"
          height="150px"
          :src="getURL(item)"
        ></image-view>
        <div class="text-center">
          <div class="subtitle-1 text-capitalize black--text">Flower</div>
          <div class="body-2">32 gb</div>
          <div class="body-2 font-weight-bold">₹100</div>
          <confirm :id="item.autono"></confirm>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { getURL } from "../../assets/js/common";
import shoppingService from "../../assets/services/shopping.service";
import ImageView from "../ImageView.vue";
import Confirm from "./Confirm.vue";
export default {
  components: {
    ImageView,
    Confirm,
  },
  data() {
    return {
      items: [],
    };
  },
  methods: {
    getURL({ image_path }) {
      return getURL(image_path);
    },
    async init() {
      const vm = this;
      try {
        vm.$loader.show();
        let { data } = await shoppingService.list();
        if (data.status == "true") {
          vm.items = data.data;
        } else {
          vm.$alert.show(data.message);
        }
        vm.$loader.hide();
      } catch (error) {
        vm.$alert.show(error.message);
        vm.$loader.hide();
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
</style>